import { render, staticRenderFns } from "./GoodsLive.vue?vue&type=template&id=9564f538&scoped=true"
import script from "./GoodsLive.vue?vue&type=script&lang=js"
export * from "./GoodsLive.vue?vue&type=script&lang=js"
import style0 from "./GoodsLive.vue?vue&type=style&index=0&id=9564f538&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9564f538",
  null
  
)

export default component.exports